"use client";

import { AuthProvider, useAuth } from "@/lib/auth-context";
import LoginPage from "@/components/login-page";
import { AssistantHub } from "@/components/assistant-hub";
import { Loader2 } from "lucide-react";

// הוצאנו את AppContent החוצה כדי שנוכל להשתמש בו גם בדף הדינמי
export function AppContent({ id }: { id?: string }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="animate-spin text-blue-900" size={48} />
      </div>
    );
  }

  // העברת ה-ID כפרופ התחלתי ל-Hub
  return isAuthenticated ? <AssistantHub initialManualId={id} /> : <LoginPage />;
}

export default function Home() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}